import {
  symbols as CURRENCIES,
  UNIT_LABELS,
} from '@components/ArtBoard/Estimator/constants'
import {
  DndContext,
  type DragEndEvent,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import { SortableContext, sortableKeyboardCoordinates } from '@dnd-kit/sortable'
import type { EstimateLineItem } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { updateLineItemIndex } from '@store/reducers/estimates/actions'
import type { AppState } from '@store/types'
import type React from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import type { Action } from 'redux'
import type { ThunkDispatch } from 'redux-thunk'

import css from './Table.module.scss'
import { TableItem } from './TableItem'

type Props = {
  items: EstimateLineItem[]
  currency: string
}

export type SelectedCell = Record<string, string | null>

export const Table: React.FC<Props> = ({ items, currency }) => {
  const [selectCell, setSelectCell] = useState<SelectedCell | null>(null)

  const dispatch = useDispatch<ThunkDispatch<AppState, unknown, Action>>()

  const unit = useSelector(migrationProjectSelector.getProjectEstimateUnits)

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  )

  // const handleDeleteItem = (id: string) => {
  //   dispatch(
  //     openSystemDialog(DialogTypes.DELETE_LINE_ITEM_ESTIMATE, {
  //       title: 'Remove estimate row',
  //       text: 'Are you sure you want to delete this row?',
  //       btnText: 'Remove',
  //       onSuccess: () => {
  //         dispatch({
  //           type: ActionTypes.COMMIT_PROJECT_REQUEST,
  //           payload: {
  //             type: ActionTypes.DELETE_LINE_ITEM,
  //             payload: { id },
  //           },
  //           history: false,
  //         })
  //       },
  //     })
  //   )
  // }

  // const handleUpdateEstimate = (payload: EstimateTableItem) => {
  //   dispatch({
  //     type: ActionTypes.COMMIT_PROJECT_REQUEST,
  //     payload: {
  //       type: ActionTypes.UPDATE_LINE_ITEM,
  //       payload,
  //     },
  //     history: false,
  //   })
  // }

  const handleDragEnd = ({ active, over }: DragEndEvent) => {
    if (over && active.id !== over.id) {
      if (!items) {
        return null
      }

      const hoverIndex = items.findIndex(({ id }) => id === over.id)

      dispatch(
        updateLineItemIndex({ id: active.id as string, index: hoverIndex })
      )
    }
  }

  return (
    <div className={css.wrapper}>
      <div className={css.table}>
        <div className={css.tableHeading}>
          <div className={css.tableRow}>
            <div className={css.tableHead}>Item</div>
            <div className={css.tableHead}>
              Rate, {CURRENCIES[currency as keyof typeof CURRENCIES]}
            </div>
            <div className={css.tableHead}>{UNIT_LABELS[unit]}</div>
            <div className={css.tableHead}>
              Amount, {CURRENCIES[currency as keyof typeof CURRENCIES]}
            </div>
          </div>
        </div>
        <div className={css.tableBody}>
          <DndContext sensors={sensors} onDragEnd={handleDragEnd}>
            <SortableContext items={items || []}>
              {items.map((item, index) => (
                <TableItem
                  key={index}
                  item={item}
                  unitKey={unit}
                  selectedCell={selectCell}
                  onSelectCell={setSelectCell}
                />
              ))}
            </SortableContext>
          </DndContext>
        </div>
      </div>
    </div>
  )
}
